import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useParseDocumentToHtml } from '~/composables/useParseDocumentToHtml';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'RichText',
  props: {
    text: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    customRenderer: {
      type: Object,
      default: function _default() {
        return {
          renderNode: {},
          renderMark: {}
        };
      }
    },
    links: {
      type: Map,
      default: function _default() {
        return undefined;
      }
    },
    linkAsCta: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _toRefs = toRefs(props),
      text = _toRefs.text,
      displayOptions = _toRefs.displayOptions,
      customRenderer = _toRefs.customRenderer,
      links = _toRefs.links;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useParseDocumentToHt = useParseDocumentToHtml(text.value, displayOptions.value, customRenderer.value, links.value, locale),
      parsedText = _useParseDocumentToHt.html;
    return {
      __sfc: true,
      props: props,
      text: text,
      displayOptions: displayOptions,
      customRenderer: customRenderer,
      links: links,
      locale: locale,
      parsedText: parsedText
    };
  }
});